<template>
  <!-- 测试组件容器 -->
  <div class="test-container">
    <h1>测试组件</h1>
    <p>如果能看到这个页面，说明路由工作正常</p>
    <button @click="testLog">测试 Console 输出</button>
    <!-- 显示日志记录 -->
    <div v-for="(log, index) in logs" :key="index">
      <p>{{ log }}</p>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'TestComponent',
  data() {
    return {
      // 存储日志记录的数组
      logs: []
    }
  },
  mounted() {
    // 组件挂载时记录日志
    console.log('TestComponent 已挂载');
    this.logs.push('TestComponent 已挂载 - ' + new Date().toString());
  },
  methods: {
    // 测试按钮点击事件处理函数
    testLog() {
      // 输出不同类型的日志
      console.log('测试按钮被点击');
      console.error('测试错误输出');
      console.warn('测试警告输出');
      
      // 将日志添加到页面显示
      this.logs.push('测试按钮被点击 - ' + new Date().toString());
    }
  }
}
</script>

<style scoped>
/* 测试组件容器样式 */
.test-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
</style>